var map = {
	"./en/index.scss": [
		"tXzd",
		0
	],
	"./zh/index.scss": [
		"38NE",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "UkVB";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/styles lazy ^\.\/.*\/index\.scss$
// module id = UkVB
// module chunks = 3